import React from 'react';
import styled from 'styled-components';
import dt from '../../../shared/theme';

const LW_DISCLAIMER = 'Livewire gives readers access to content provided by '
  + 'financial services professionals and companies ("Livewire Contributors”). '
  + 'Fund data is provided by Morningstar for personal use only. While every '
  + 'care has been taken in producing these numbers, neither Livewire nor '
  + 'Morningstar can guarantee the complete accuracy of these figures. Should '
  + 'you decide to invest, please read the relevant disclosure documents and '
  + 'consider speaking to a professional. A tax event may be realised when '
  + 'switching investments. Past performance is not a reliable indicator of '
  + 'future performance. Livewire does not operate under an Australian '
  + 'Financial Services Licence (AFSL) and relies on the exemption under '
  + '911A(2)(eb) of the Corporations Act 2001 in respect to any advice given. '
  + 'The advice on this site is general in nature and does not take into '
  + 'account your personal needs or objectives.';

const Container = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  margin: ${props => (dt(props).theme.isMobile ? '80px 0 0' : '72px 0 66px')};
  background: #F8F9FB;
  height: ${props => (dt(props).theme.isMobile ? 276 : 120)}px;
  width: 100%;
`;

const Content = styled.div`
  white-space: pre-wrap;
  color: ${props => dt(props).theme.secondaryColor};
  font-size: 14px;
  padding: 24px 20px;

  ${props => dt(props).theme.isXXLarge && `
    padding: 25px 175px;
  `};
`;

export default function Disclaimer() {
  return (
    <Container>
      <Content>{LW_DISCLAIMER}</Content>
    </Container>

  );
}
